module.exports = __webpack_public_path__ + "img/q-9-2@2x.5778687c.png";